// extracted by mini-css-extract-plugin
export default {"cont":"ReferalProgressBar_cont__gjJ5c","valueLabel":"ReferalProgressBar_valueLabel__JOrBF","fragmentImage":"ReferalProgressBar_fragmentImage__mfZhR"};